import React, { useContext } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { newRegionSchema } from '../../../util/validationSchema'
import { yupResolver } from '@hookform/resolvers/yup'
import { addRegion } from '../../../redux/slices/regionSlice'
import { SpinnerContext } from '../../../context/spinnerContext'
import { errorToast, successToast } from '../../../util/Toast/toast'

const NewRegion = ({ toggle, setIsRefresh }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const { handleSubmit, control, trigger } = useForm({
    resolver: yupResolver(newRegionSchema),
    defaultValues: {
      is_pricingTable_add: false
    }
  })

  const onSubmit = (data) => {
    setIsRefresh(false)
    const payload = {
      region: data?.region,
      is_pricingTable_add: data?.is_pricingTable_add
    }
    dispatch(addRegion(payload))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggle()
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group">
            Region <span className="text-danger"> *</span>
            <Controller
              name="region"
              control={control}
              render={({ field: { value, onChange }, fieldState }) => (
                <>
                  <input
                    className="form-control"
                    value={value}
                    type="text"
                    placeholder="Enter Region"
                    onChange={(val) => {
                      onChange(val)
                      trigger('region')
                    }}
                  />
                  <small>{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
          <div className="form-group d-flex">
            <Controller
              name="is_pricingTable_add"
              control={control}
              render={({ field: { onChange, value } }) => (
                <>
                  <label className="d-flex align-items-center">
                    <input
                      className="custom-checkbox m-0"
                      type="checkbox"
                      checked={value}
                      onChange={(e) => {
                        onChange(e.target.checked)
                      }}
                    />
                  </label>
                </>
              )}
            />
            <span className="dont-have" style={{ marginLeft: 15, color: '#444444B2' }}>
              Would you like to add a default pricing table for your regions?
            </span>
          </div>
        </div>
      </div>
      <div className="multi_btn_div">
        <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary common-field-btn w-100">
          {`Save`}
        </button>
      </div>
    </form>
  )
}

export default NewRegion
